import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '@tv3/shared/shared.module'
import { TemplatesSharedModule } from '@tv3/containers/templates/templates-shared.module'
import { AutomationsLibraryModule } from '@tokeet-frontend/automations'
import { AutomationsTableComponent } from './automations-table/automations-table.component'
import { AutomationGridCardComponent } from './grid-view/automation-grid-card/automation-grid-card.component'
import { AutomationGridComponent } from './grid-view/automation-grid.component'
import { AutomationDateFormComponent } from './automation-data-form/date-form/automation-date-form.component'
import { AutomationExpenseDataFormComponent } from './automation-data-form/expense/form/automation-expense-data-form.component'
import { AutomationIncidentDataFormComponent } from './automation-data-form/incident/form/automation-incident-data-form.component'
import { AutomationTaskDataDialogComponent } from '@tv3/containers/automations/automation-data-form/task/dialog/automation-task-data-dialog.component'
import { AutomationTaskDataFormComponent } from '@tv3/containers/automations/automation-data-form/task/form/automation-task-data-form.component'
import { AutomationExpenseDataDialogComponent } from '@tv3/containers/automations/automation-data-form/expense/dialog/automation-expense-data-dialog.component'
import { AutomationIncidentDataDialogComponent } from '@tv3/containers/automations/automation-data-form/incident/dialog/automation-incident-data-dialog.component'
import { IncidentLibraryModule } from '@tokeet-frontend/incident'
import { AutomationLogsModule } from '@tv3/containers/automations/automation-logs/automation-logs.module'
import { AutomationsDialogComponent } from '@tv3/containers/automations/automations-dialog/automations-dialog.component'
import { AutomationsDialogService } from '@tv3/containers/automations/automations-dialog/automations-dialog.service'
import { AutomationGridCardNameDirective } from '@tv3/containers/automations/grid-view/automation-grid-card/automation-grid-card-name.directive'
import { VendorsLibraryModule } from '@tokeet-frontend/vendors'
import { TasksSharedModule } from '@tv3/containers/tasks/tasks-shared.module'

const components = [
  //
  AutomationDateFormComponent,
  AutomationExpenseDataFormComponent,
  AutomationExpenseDataDialogComponent,
  AutomationTaskDataFormComponent,
  AutomationTaskDataDialogComponent,
  AutomationIncidentDataFormComponent,
  AutomationIncidentDataDialogComponent,

  AutomationGridComponent,
  AutomationGridCardComponent,
  AutomationsTableComponent,
  AutomationsDialogComponent,
]

const modules = [
  //
  SharedModule,
  AutomationsLibraryModule,
  TemplatesSharedModule,
  IncidentLibraryModule,
  AutomationLogsModule,
  VendorsLibraryModule,
  TasksSharedModule,
]
const services = [
  //
  AutomationsDialogService,
]

const pipes = [
  //
  AutomationGridCardNameDirective,
]

@NgModule({
  imports: [CommonModule, ...modules],
  declarations: [...components, ...pipes],
  providers: [...services],
  exports: [...components, ...modules],
})
export class AutomationsSharedModule {}
